import { render } from "./App.vue?vue&type=template&id=e9617b1e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e9617b1e&lang=css"

import exportComponent from "E:\\araya_2021\\tokuten\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__